import React from 'react';
import { MessageSquare } from 'lucide-react';

function PresenterCommentsButton({ isActive, onClick, onMouseEnter }) {
  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      aria-expanded={isActive}
      aria-label={isActive ? 'Close comments' : 'Open comments'}
      className={[
        'inline-flex shrink-0 items-center justify-center gap-1.5 rounded-full h-9 border px-3 text-sm font-medium shadow-sm transition-colors',
        'focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1',
        isActive
          ? 'border-indigo-200 bg-indigo-50 text-indigo-700 hover:bg-indigo-100'
          : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50 hover:text-gray-900',
      ].join(' ')}
    >
      <MessageSquare className="h-4 w-4 shrink-0" aria-hidden />
      <span className="hidden sm:inline">Comments</span>
    </button>
  );
}

export default PresenterCommentsButton;
